import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import CategoryDropdown from './CategoryDropdown';

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative flex min-h-[640px] w-full items-center justify-center overflow-hidden md:min-h-[720px]">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://readdy.ai/api/search-image?query=A%20stylized%20artistic%20flat%20lay%20of%20assorted%20fashion%20products%20including%20sneakers%2C%20a%20denim%20jacket%2C%20a%20folded%20hoodie%2C%20a%20cap%20and%20accessories%20arranged%20in%20a%20soft%20radial%20composition%20on%20a%20muted%20sage%20and%20cream%20backdrop%20with%20gentle%20gradients%20and%20soft%20studio%20light%2C%20premium%20editorial%20mood%2C%20high%20detail&width=1600&height=900&seq=hero-usfans&orientation=landscape&nocache=true')",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>

      <div className="relative z-10 mx-auto w-full max-w-4xl px-4 py-24 text-center md:px-6">
        <span className="inline-flex items-center gap-2 rounded-full bg-background-50/15 px-4 py-1.5 text-xs font-semibold text-background-50 backdrop-blur-sm whitespace-nowrap">
          <span className="flex h-3.5 w-3.5 items-center justify-center">
            <i className="ri-sparkling-2-line text-sm leading-none"></i>
          </span>
          {t('hero.trust')}
        </span>

        <h1 className="mt-6 font-heading text-3xl font-extrabold leading-tight tracking-tight text-background-50 md:text-5xl">
          {t('hero.h1')}
        </h1>

        <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-background-100 md:text-lg">
          {t('hero.subtitle')}
        </p>

        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-primary-500 px-7 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap sm:w-auto cursor-pointer"
          >
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-external-link-line text-base leading-none"></i>
            </span>
            {t('hero.usfansSpreadsheet')}
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-accent-500 px-7 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-600 whitespace-nowrap sm:w-auto cursor-pointer"
          >
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-shopping-bag-3-line text-base leading-none"></i>
            </span>
            {t('hero.buyNow')}
          </a>
        </div>

        <Link
          to="/usfans-spreadsheet"
          className="mt-4 inline-flex items-center gap-1.5 text-sm font-medium text-background-100 underline-offset-4 transition-colors hover:text-background-50 hover:underline cursor-pointer"
        >
          {t('hero.startGuide')}
          <span className="flex h-4 w-4 items-center justify-center">
            <i className="ri-arrow-right-line text-base leading-none"></i>
          </span>
        </Link>

        <p className="mx-auto mt-8 max-w-xl text-sm leading-relaxed text-background-200">
          {t('hero.microcopy')}
        </p>

        <div className="mx-auto mt-8 flex justify-center">
          <CategoryDropdown />
        </div>
      </div>
    </section>
  );
}